import React from "react";
import classNames from "classnames";
import { Loader } from "@design-system/Loader/Loader";
import { StateAwareLink } from "@components/routes/StateAwareLink";
import { Tag } from "@design-system/Tag/Tag";
import { ArrowRightIcon, ArrowDownIcon } from "@icons";
import styles from "./AccountingReportLink.module.scss";

interface Props {
    title: React.ReactNode;
    description: string;
    active?: boolean;
    link?: string;
    onClick?: () => void;
    comingSoon?: boolean;
    loading?: boolean;
}

export const AccountingReportLink: React.FC<Props> = ({
    title,
    description,
    active,
    link,
    comingSoon,
    onClick,
    loading,
}) => {
    const icon = onClick ? <ArrowDownIcon /> : <ArrowRightIcon />;
    const inner = (
        <>
            <div className={styles.title}>
                {title}

                {comingSoon && (
                    <Tag className={styles.comingSoon} color="neutral">
                        Coming Soon
                    </Tag>
                )}
            </div>
            <div className={styles.description}>{description}</div>
            <span className={styles.icon}>
                {loading ? <Loader inline /> : icon}
            </span>
        </>
    );

    if (link) {
        return (
            <StateAwareLink
                to={link}
                className={classNames(styles.section, {
                    [styles.active]: active,
                })}
            >
                {inner}
            </StateAwareLink>
        );
    }

    return (
        <div
            onClick={onClick}
            className={classNames(styles.section, {
                [styles.active]: active,
                [styles.sectionNoClickable]: !onClick,
            })}
        >
            {inner}
        </div>
    );
};
